







































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import TabularHeader from '@/modules/shared/components/shared/TabularHeader.vue'
import { ContentCampaignResourceType } from '@/modules/content-campaign/models/content-campaign-resource.model'
import CampaignStatusView from '@/modules/base-campaign/components/shared/CampaignStatusView.vue'
import DateTooltipped from '@/modules/shared/components/shared/utils/DateTooltipped.vue'
import AdminContentCampaignTabularActions
  from '@/modules/content-campaign/components/admin/AdminContentCampaignTabularActions.vue'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsis.vue'
import MediaAttachmentDialog from '@/modules/media/components/shared/MediaAttachmentDialog.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { DateHelper } from '@/modules/shared/helpers/date'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import AlertNotification from '@/modules/notification/components/panel/AlertNotification.vue'
import {
  panelContentCampaignShowTabularColumn
} from '@/modules/content-campaign/models/columns/content-campaign-show-tabular.column'
import PanelContentCampaignTabularActions
  from '@/modules/content-campaign/components/panel/PanelContentCampaignTabularActions.vue'

@Component({
  components: {
    PanelContentCampaignTabularActions,
    AlertNotification,
    BaseInput,
    Modal,
    BaseButton,
    MediaAttachmentDialog,
    TabularHeader,
    CampaignStatusView,
    DateTooltipped,
    AdminContentCampaignTabularActions,
    TextEllipsis
  }
})
export default class PanelContentCampaignShowTabular extends Vue {
  constructor(
    private readonly date: DateHelper
  ) {
    super()
  }

  @Prop({ required: true }) contentCampaign: ContentCampaignResourceType
  private columnsData = panelContentCampaignShowTabularColumn()

  get campaign() {
    return this.contentCampaign.data
  }

}
